import { render, staticRenderFns } from "./AddSurvey.vue?vue&type=template&id=2b0dc9a6&scoped=true"
import script from "./AddSurvey.vue?vue&type=script&lang=js"
export * from "./AddSurvey.vue?vue&type=script&lang=js"
import style0 from "./AddSurvey.vue?vue&type=style&index=0&id=2b0dc9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dc9a6",
  null
  
)

export default component.exports